module.exports = __webpack_public_path__ + "static/ChopperBikeRed-1bb124c802e9252fe0a7bc0497612f2f.mp4";